exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.icon[data-v-be5c876c]:hover {\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/web/kls-admin-portal/src/components/player_control/volume.vue","/home/vsts/work/1/s/web/kls-admin-portal/src/components/player_control/volume.vue"],"names":[],"mappings":";AAqGE;EACE,gBAAA;CCpGH","file":"volume.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.icon{\n  &:hover{\n    cursor: pointer;\n  }\n}\n",".icon:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be5c876c","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/player_control/volume.vue
// module id = 71iI
// module chunks = 21